export default {
    user_not_active: `User is not active or doesn't exist`,
    fields: {
        user_id: {
            label: 'Please enter the user id that you want to activate',
            placeholder: 'Enter the id here',
        },
    },
}
